module.exports = __webpack_public_path__ + "static/media/img_4.a8a9d301.png";